import type { AuthenticationPort } from '@/domains/auth/AuthenticationPort'
import type { LocationPort } from '@/domains/auth/LocationPort'

export const AUTH_PAGES = ['/token', '/silent-renew']

type Args = {
  auth: AuthenticationPort
  location: LocationPort
  authPages: string[]
}

export type AuthDecision =
  { type: 'allow' } | { type: 'login'; returnTo: string } | { type: 'redirect'; to: string }

export const canAccessRoute = async ({
  auth,
  location,
  authPages = AUTH_PAGES,
}: Args): Promise<AuthDecision> => {
  const path = location.currentPath()
  const search = location.currentSearch() ?? ''
  const isExempt = authPages.some((p) => path.startsWith(p))

  const isAuth = await auth.isAuthenticated()

  if (!isAuth && !isExempt) {
    return { type: 'login', returnTo: path + search }
  }

  if (isAuth && isExempt) {
    return { type: 'redirect', to: '/' }
  }

  return { type: 'allow' }
}
